/* eslint-disable eqeqeq */
import React, { useState, useLayoutEffect, useRef } from "react";

/** Components */
import {
  ButtonGroup,
  Button,
  TablePagination,
  Paper,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableFooter,
  Collapse,
  Popper,
  MenuItem,
  ClickAwayListener,
  MenuList,
  Select,
  Dialog,
  Tooltip,
} from "@mui/material";
import { FilterBy } from "../../commons/filter.component";
import { TreeMenu } from "../../commons/renderTreeMenu.component";
import FuelTicketDetail from "./fuelTicketDetail.component";
import LoadingProgress from "../../commons/LoadingProgress.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */
import { getCustomers, getFuelTicketMenu, getFuelTickets, getInventory } from "../../../services/api";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";

/** Api & Function */
import { convertQueryStringToObject } from "../../../services/libService";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import moment from "moment";

/** Hook */
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { statusColor } from "../../config";
import { useParamFilter } from "../../commons/customHook";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

export default function FuelTicket() {
  // hook
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const { fetchData, data, setData, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter({ page: 1, per_page: 50, ft_type: 1 }, getFuelTickets);
  const history = useHistory();
  const location = useLocation();
  // state
  const [treeData, setTreeData] = useState();
  const [isSearchOpen, setSearchOpen] = useState(true);
  const filter = convertQueryStringToObject(location.search);
  const [input, setInput] = useState({
    selectedCustomer: null,
    start_date: filter.start_date || null,
    end_date: filter.end_date || null,
    selectedInventory: null,
    code: filter.code || null,
  });

  const handleRowClick = (e, id) => {
    history.push(`/fuelticket/${id}${location.search}`);
  };
  const handleUpdate = (res, newItem) => {
    if (res.code === 200 && newItem && newItem.id) {
      setData((prev) => prev.map((item) => (item.id == newItem.id ? newItem : item)));
    }
  };
  const handleSearch = () => {
    fetchData((prev) => ({ ...input, ft_type: prev.ft_type, selectedCustomer: null, customer_id: input.selectedCustomer?.id, selectedInventory: null, inventory_id: input.selectedInventory?.id }));
  };
  useLayoutEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN PHIẾU XUẤT TRẢ HÀNG GỬI"));
    fetchData(filter);
    getFuelTicketMenu().then((res) => {
      setTreeData(res.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div style={{ backgroundColor: "#b3deff", marginBottom: 20, marginTop: 10, display: "flex", justifyContent: "space-between", height: 40 }}>
        <Select style={{ height: 40, marginLeft: 5 }} value={filter.ft_type || ""} onChange={(e) => fetchData((prev) => ({ ...prev, ft_type: e.target.value }))}>
          <MenuItem value={1}>Phiếu xuất trả hàng gửi máy bay</MenuItem>
          <MenuItem value={2}>Phiếu xuất trả hàng gửi xe bồn</MenuItem>
          <MenuItem value={3}>Phiếu xuất trả hàng gửi kho đầu nguồn</MenuItem>
          {/* <MenuItem value={4}>Phiếu xuất trả hàng gửi tại giàn xuất</MenuItem> */}
          <MenuItem value={0}>Phiếu xuất khác</MenuItem>
        </Select>
        <ButtonGroup variant="outlined" style={{ height: 40, marginRight: 10 }}>
          <Button onClick={() => setSearchOpen((prev) => !prev)}>
            <Tooltip title="Thư mục">
              <SearchIcon />
            </Tooltip>
          </Button>
          <Tooltip title="Tạo mới">
            <DropdownActions />
          </Tooltip>
        </ButtonGroup>
      </div>
      <Collapse in={isSearchOpen} align="right" style={{ paddingRight: 20 }}>
        <TextField
          label={t("Mã tra cứu")}
          value={input.code || ""}
          onChange={(e) => setInput((prev) => ({ ...prev, code: e.target.value }))}
          style={{ margin: 5, marginTop: 4 }}
          InputProps={{ style: { minWidth: 200 } }}
          InputLabelProps={{ shrink: true, style: { fontSize: 15 } }}
        />
        <FilterBy
          getDataFunc={getCustomers}
          style={{ display: "inline-flex", width: 240, margin: 5 }}
          label={t("Khách hàng")}
          value={input.selectedCustomer || null}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, selectedCustomer: newValue }))}
        />
        <FilterBy
          getDataFunc={getInventory}
          style={{ display: "inline-flex", width: 240, margin: 5 }}
          label={t("Kho hàng")}
          value={input.selectedInventory || null}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, selectedInventory: newValue }))}
        />
        <CustomDatePicker
          format="DD/MM/YYYY"
          label={t("Từ ngày")}
          value={input.startTime}
          onChange={(value) => setInput((prev) => ({ ...prev, startTime: value }))}
          sx={{ minWidth: "240px", margin: "5px" }}
        />
        <CustomDatePicker
          format="DD/MM/YYYY"
          label={t("Đến ngày")}
          value={input.endTime}
          onChange={(value) => setInput((prev) => ({ ...prev, endTime: value }))}
          sx={{ minWidth: "240px", margin: "5px" }}
        />
        <Button onClick={handleSearch} variant="outlined">
          {t("Tìm kiếm")}
        </Button>
      </Collapse>
      <div style={{ display: "flex" }}>
        <TreeMenu
          data={treeData}
          onClick={(query) => fetchData((prev) => ({ ...query, ft_type: prev.ft_type, per_page: prev.per_page }))}
          isExpand={!isSearchOpen}
          onExpand={() => setSearchOpen(false)}
        />
        {loading ? (
          <LoadingProgress />
        ) : (
          <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }}>
            <Table>
              <TableHead style={{ backgroundColor: "#f0f3f5" }}>
                <TableRow>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    ID
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t("Số phiếu")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t("Ngày")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t(filter.ft_type == 1 ? "Số chuyến bay" : "Số xe")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t(filter.ft_type == 1 ? "Tuyến bay" : "Từ kho")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t("Số lượng")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t("Đơn vị tính")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t("Tỉ trọng")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    {t("Nhiệt độ")}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    USG
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                    Lit
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Trạng thái")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.length ? (
                  data.map((item, index) => (
                    <TableRow hover style={{ cursor: "pointer" }} key={index} onClick={(e) => handleRowClick(e, item.id)}>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                        {item.id}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                        {item.code}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                        {item.valid_date && moment(item.valid_date).format("DD/MM/YYYY")}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                        {item.ft_type == 1 ? item.flight_no : item.refueler_no}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                        {item.ft_type == 1 ? item.route : item.inventory_name}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                        {item.quantity.toLocaleString()}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                        {item.productunit_code}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                        {item.density && (+item.density).toFixed(4)}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                        {item.temp && (+item.temp).toFixed(2)}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                        {item.gallon.toLocaleString()}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                        {item.lit.toLocaleString()}
                      </TableCell>
                      <TableCell style={{ border: "0.5px solid lightgray" }}>
                        <div className={`status ${item.status}`} style={{ color: statusColor[item.status] }}>
                          {t(item.status)}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={20}>
                      {t(isAllow ? "Không có dữ liệu" : "No permission")}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        )}
      </div>
      <Detail onUpdate={handleUpdate} />
    </div>
  );
}

const DropdownActions = React.forwardRef(({ ...buttonProps }, ref) => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const internalRef = useRef();
  const [t] = useTranslation();

  // Use the forwarded ref or fallback to internal ref
  const buttonRef = ref || internalRef;

  return (
    <React.Fragment>
      <Button ref={buttonRef} {...buttonProps} onClick={() => setOpen((prev) => !prev)}>
        <MoreVertIcon />
      </Button>
      <Popper open={open} anchorEl={buttonRef.current}>
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <Paper>
            <MenuList>
              {/* <MenuItem onClick={() => history.push('/fuelticket/create/airft')}>{t('Tạo phiếu bán sân bay')}</MenuItem> */}
              <MenuItem onClick={() => history.push("/fuelticket/create/airft", { is_consignment: true })}>{t("Tạo phiếu xuất trả hàng gửi máy bay")}</MenuItem>
              <MenuItem onClick={() => history.push("/fuelticket/create/refuelertruckft")}>{t("Tạo phiếu xuất trả hàng gửi xe bồn")}</MenuItem>
              <MenuItem onClick={() => history.push("/fuelticket/create/truckft")}>{t("Tạo phiếu xuất trả hàng gửi kho đầu nguồn")}</MenuItem>
              <MenuItem onClick={() => history.push("/fuelticket/create/stationft")}>{t("Tạo phiếu xuất trả hàng gửi tại giàn xuất")}</MenuItem>
            </MenuList>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </React.Fragment>
  );
});
const Detail = ({ onUpdate }) => {
  const history = useHistory();
  const location = useLocation();
  const onClose = () => {
    history.push(`/fuelticket${location.search}`);
  };
  const { fuelticketid } = useParams();
  return (
    <Dialog open={Boolean(fuelticketid)} onClose={onClose} maxWidth={false} fullWidth>
      <div align="center" style={{ padding: 10, height: "100vh" }}>
        <FuelTicketDetail id={fuelticketid} onClose={onClose} onUpdate={onUpdate} />
      </div>
    </Dialog>
  );
};
